import * as React from 'react'
import { dateOptions } from '../../../constants'
import { type IFilterMode, LimitedDateFilter } from '@user/components/Filters'

export function DueDateFilter(props: IFilterMode) {
  return (
    <LimitedDateFilter
      {...props}
      name="dueDate"
      label="Due Date"
      options={dateOptions}
    />
  )
}
